import { CommonNavigationHelper } from '@common';

export function useAppUri(appName?: string) {
    if (!appName) return '';

    let host = window.location.host;
    if (host.startsWith('www.')) host = host.substring(4);

    return CommonNavigationHelper.getAppUri({
        appName,
        host,
        protocol: window.location.protocol,
    });
}
